module.exports = __webpack_public_path__ + "images/play-icon-white_89abac691b1fed3f8a22ec3c03b3f306.svg";